import conf from 'client/conf';

export const getWebApiUrl = () => {
  if (typeof window === 'undefined') {
    return conf.STRIDE_WEB_API_URL;
  }

  return `${window.location.origin}/web-api/graphql`;
};
